import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import fMessage from '@/components/fMessage';
import {
  updateExhibitBaseInfo,
  updateExhibitOnlineStatus,
  updateRewrite as updateRewriteHelper,
  changeExhibitVersion,
  saveExhibitIntroduction,
} from '@/models/shared/exhibitHelpers';
import type {
  ChangeAction,
  UpdateBaseInfoAction,
  UpdateStatusAction,
  UpdateRewriteAction,
  ChangeVersionAction,
  OnSave_Side_ExhibitIntroduction_Action,
  FetchInfoAction,
} from './types';

export const exhibitEffects = {
  *updateBaseInfo(
    { payload }: UpdateBaseInfoAction,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );

    const result: { success: boolean; msg?: string } = yield call(updateExhibitBaseInfo, collectionExhibitInfoPage.exhibit_ID, {
      presentableTitle: payload.side_ExhibitTitle,
      tags: payload.side_ExhibitTags,
      // @ts-ignore
      presentableIntro: payload.side_ExhibitInputIntroduction || undefined,
      coverImages: payload.exhibit_Cover ? [payload.exhibit_Cover] : undefined,
    });
    if (!result.success) {
      fMessage(result.msg!, 'error');
      return;
    }
    yield put<ChangeAction>({
      type: 'change',
      payload,
    });
  },
  *updateStatus(
    { payload }: UpdateStatusAction,
    { call, select, put }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );
    const success: boolean = yield call(updateExhibitOnlineStatus, collectionExhibitInfoPage.exhibit_ID, payload);
    if (!success) {
      fMessage(
        collectionExhibitInfoPage.exhibit_ResourceInfo?.type.includes('主题')
          ? '激活失败'
          : '上线失败',
        'error',
      );
      return;
    }
    yield put<FetchInfoAction>({
      type: 'fetchInfo',
    });
  },
  *updateRewrite(
    {}: UpdateRewriteAction,
    { select, call }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );
    yield call(updateRewriteHelper, {
      exhibit_ID: collectionExhibitInfoPage.exhibit_ID,
      inheritOptions: collectionExhibitInfoPage.inheritOptions,
      customOptions: collectionExhibitInfoPage.customOptions,
    });
  },
  *changeVersion(
    { payload }: ChangeVersionAction,
    { call, put, select }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );
    const result: { success: boolean; msg?: string } = yield call(changeExhibitVersion, collectionExhibitInfoPage.exhibit_ID, payload);
    if (!result.success) {
      fMessage(result.msg!, 'error');
      return;
    }
    yield put<FetchInfoAction>({
      type: 'fetchInfo',
    });
  },
  *onSave_Side_ExhibitIntroduction(
    { payload }: OnSave_Side_ExhibitIntroduction_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { collectionExhibitInfoPage }: ConnectState = yield select(
      ({ collectionExhibitInfoPage }: ConnectState) => ({
        collectionExhibitInfoPage,
      }),
    );
    const oldText: string =
      collectionExhibitInfoPage.side_ExhibitIntroduction;
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        side_ExhibitIntroduction: payload.value,
      },
    });

    const result: { success: boolean; msg?: string } = yield call(saveExhibitIntroduction, collectionExhibitInfoPage.exhibit_ID, payload.value);
    if (!result.success) {
      fMessage(result.msg!, 'error');
      yield put<ChangeAction>({
        type: 'change',
        payload: {
          side_ExhibitIntroduction: oldText,
        },
      });
      return;
    }
  },
};
